interface ClassCardProgressProps {
  progress: number
  term: string
  status: string
  borderColor: "primary" | "secondary"
}

export function ClassCardProgress({ progress, term, status, borderColor }: ClassCardProgressProps) {
  const progressColor = borderColor === "primary" ? "bg-teal-600" : "bg-blue-800"

  return (
    <div className="mb-4">
      <div className="flex justify-between text-xs font-semibold text-gray-600 mb-1">
        <span>Class Progress</span>
        <span>{term}</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5">
        <div className={`${progressColor} h-2.5 rounded-full`} style={{ width: `${progress}%` }}></div>
      </div>
      <p className="text-xs text-right mt-1 text-gray-400">{status}</p>
    </div>
  )
}
